import classNames from 'classnames';
import { Col, Row } from 'reactstrap';

import LinkButton from 'src/app/components/Elements/Button/LinkButton';
import CapsuleIcon from 'src/app/components/Elements/CapsuleIcon';
import StandardPage from 'src/app/components/Elements/Page/Standard';
import { medications } from 'src/app/router/paths';
import { CAPSULE_ICON_STRINGS } from 'src/consts';

import styles from './styles.module.scss';

const LoggedInTransferConfirm = () => {
  return (
    <div className={styles.container}>
      <StandardPage>
        <div className={styles.containerInner}>
          <Row className={styles.firstRow}>
            <Col>
              <h1 className={classNames(styles.title, 'title-1', 'strong')}>Hooray!</h1>
              <p className={classNames(styles.bodyText, 'normal')}>
                We&#8217;re working on your transfer now and will text you with updates along the way.
              </p>
            </Col>
          </Row>
          <div className={styles.callOutSection}>
            <Row>
              <Col xs={2}>
                <CapsuleIcon iconString={CAPSULE_ICON_STRINGS.system_info} />
              </Col>
              <Col xs={10}>
                <h3 className="title-3">Did you know that any doctor can e-prescribe to Capsule?</h3>
                <p className="normal">
                  The next time your doctor asks, &ldquo;What&#8217;s your pharmacy?&rdquo; just say,
                  &ldquo;Capsule!&rdquo; your pharmacy? say, &rdquo;Capsule.&ldquo;
                </p>
              </Col>
            </Row>
          </div>
          <LinkButton to={medications.toPath()} style="secondary" size="medium" block data-cy="ok">
            Ok
          </LinkButton>
        </div>
      </StandardPage>
    </div>
  );
};

export default LoggedInTransferConfirm;
